import { WorkspaceState } from '.';

export function selectHasMoreDocuments(state: any): boolean {
  const workspace = state.workspace as WorkspaceState;

  return workspace.documents.length < workspace.totalFiles;
}
